import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allActividadesAcademicasAction } from '../ActividadesAcademicasAction';

const SelectFieldActividadesAcademicasComponent = ({
  onChange,
  id,
  data,
  isEmpty = true,
  value = '',
  selects = [],
  isAutoComplete,
  required = false,
  error = false,
  label,
}) => {
  const dispatch = Redux.useDispatch();

  const actividadesAcademicasStore = Redux.useSelector(
    (state) => state.actividadesAcademicas,
  );

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && actividadesAcademicasStore.all.length === 0) {
        await allActividadesAcademicasAction(dispatch, null);
        setItems(actividadesAcademicasStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      actividadesAcademicasStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(actividadesAcademicasStore.all);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  return (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`label_${id}`}>
        {label ?? CONST.actividades.label}
      </InputLabel>
      <Select
        id={CONST.ID}
        value={value}
        labelId={`label_${id}`}
        label={label ?? CONST.actividades.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty && (
          <MenuItem key={`${id}-000-item`} value={null}>
            NINGUNO
          </MenuItem>
        )}
        {items.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
      {error && <FormHelperText>Este campo requerido</FormHelperText>}
    </FormControl>
  );
};

SelectFieldActividadesAcademicasComponent.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectFieldActividadesAcademicasComponent;
